export const base = {
  "components.routes.pages.Error404.title": "Страница не найдена",
  "components.routes.pages.Error404.description": "Возможно, она была удалена или адрес введён неверно.",
  "components.routes.pages.Error404.backHome": "Вернуться на главную",
  "components.molecules.FavoriteItem.text": "Избранное",
  "components.molecules.BalanceInfo.balance": "Баланс",
  "components.molecules.BalanceInfo.total": "Портфолио",
  "components.organisms.AuthHeader.addEvenet": "Создать событие",
  "components.organisms.AuthHeader.deposit": "Депозит",
  "components.organisms.AuthHeader.search": "Поиск по рынку",
  "components.templates.CabinetTemplate.all": "Все",
  "components.molecules.StatisticsBlock.contract": "Сделок",
  "components.molecules.StatisticsBlock.chart": "Объём торгов",
  "components.molecules.StatisticsBlock.coin": "Профит / Потери",
  "components.atoms.FileInput.text": "Загрузить",
  "components.organisms.ProfileInfo.edit": "Редактировать",
  "components.organisms.ProfileInfo.deposit": "Депозит",
  "components.organisms.ProfileInfo.withdrow": "Вывод",
  "components.templates.CabinetTemplate.position": "Позиции",
  "components.templates.CabinetTemplate.history": "История",
  "components.templates.CabinetTemplate.events": "Мои события",
  "components.templates.CabinetTemplate.referals": "Реферальная система",
  "components.routes.pages.Notifications.title": "УВЕДОМЛЕНИЯ",
  "components.routes.pages.Histories.title": "История",
  "components.routes.pages.Referals.title": "Реферальная система",
  "components.routes.pages.Events.title": "Мои события",
  "components.routes.pages.Positions.title": "Позиции",
  "components.routes.pages.Positions.table.event": "событие",
  "components.routes.pages.Positions.table.value": "исход",
  "components.routes.pages.Positions.noData": "Больше не найдено позиций",
  "components.routes.pages.Histories.noData": "Больше не найдено историй",
  "components.routes.pages.Notifications.noData": "Уведомлений нет",
  "components.routes.pages.Histories.table.event": "событие",
  "components.routes.pages.Histories.table.input": "ваш исход",
  "components.routes.pages.Histories.table.output": "Итог",
  "components.routes.pages.Histories.table.profit": "ВАш выигрыш",
  "components.routes.pages.Events.noData": "Больше не найдено событией",
  "components.routes.pages.Events.table.status": "статус",
  "components.routes.pages.Events.table.event": "СОбытие",
  "components.routes.pages.Events.table.status.moderation": "На модерации",
  "components.routes.pages.Events.table.status.posted": "Опубликован",
  "components.routes.pages.Referals.table.nikName": "ник",
  "components.routes.pages.Positions.table.bonus": "МОЙ бонус",
  "components.routes.pages.Positions.table.date": "дата",
  "components.routes.pages.Referals.noData": "Больше не найдено бонусов",
  "components.routes.pages.Referals.noDataBack": "список пуст",
  "components.routes.pages.EditProfile.title": "Профиль",
  "components.forms.EditProfileForm.nikname": "Никнейм",
  "components.forms.EditProfileForm.description": "Описание",
  "components.forms.EditProfileForm.saveBtn": "Сохранить",
  "components.forms.EditProfileForm.email": "Электронная почта",
  "components.forms.EditProfileForm.password": "Пароль",
  "components.forms.EditProfileForm.theme": "Тема",
  "components.forms.EditProfileForm.theme.light": "Светлая",
  "components.forms.EditProfileForm.theme.dark": "Темная",

  "components.forms.EditProfileForm.nikname.placeholder":
    "Напишите ваш никнейм ",
  "components.forms.EditProfileForm.description.placeholder":
    "Напишите что-нибудь о себе...",
  "components.forms.EditProfileForm.email.placeholder": "Напишите вашу почту",
  "components.forms.EditProfileForm.password.placeholder":
    "Напишите ваш пароль",
  "components.forms.EditProfileForm.returnBtn": "Вернуться в профиль",
  "components.organisms.ReferalInfo.promocode.placeholder":
    "Напишите ваш промокод",
  "components.organisms.ReferalInfo.promocode": "Ваш промокод",
  "components.organisms.ReferalInfo.btn": "Поделиться с друзьями",
  "components.organisms.ReferalInfo.title": "Описание механики",
  "components.organisms.ReferalInfo.text":
    "Тут ты найдешь свой уникальный промокод. Делись им с друзьями и получай за них бонусы. Чем больше людей — тем больше бонусов! Тот, кто используют твой промокод, тоже получит бонус при первом депозите.",
  "components.organisms.ReferalInfo.textInfo":
    "С первого депозита приглашённого пользователя ты мгновенно получаешь бонус на свой баланс.",
  "components.organisms.Footer.logoTitle": "Биржа прогнозов “Trend Trade”",
  "components.organisms.Footer.logoDescription":
    "Копирование материалов разрешено только с письменного согласия платформы и активной ссылкой на источник. Все материалы платформы являются интеллектуальной собственностью и защищены законом об авторских правах.",
  "components.organisms.Footer.terms": "Условия использования",
  "components.organisms.Footer.policy": "Поддержка",
  "components.routes.pages.Terms.title": "Условия использования",
  "components.organisms.Footer.navigation": "Навигация",
  "components.organisms.Footer.navigation.root": "Главная",
  "components.organisms.Footer.navigation.favorites": "Избранное",
  "components.organisms.Footer.account": "Аккаунт",
  "components.organisms.Footer.account.settings": "Настройки",
  "components.organisms.Footer.account.deposit": "Депозит",
  "components.organisms.Footer.account.positions": "Позиции",
  "components.organisms.Footer.account.history": "История",
  "components.organisms.Footer.account.events": "Мои события",
  "components.organisms.Footer.account.promocodes": "Промокоды",
  "components.organisms.Footer.account.referal": "Реф. система",
  "components.organisms.Footer.sites": "Наши социальные сети",
  "components.routes.pages.Favorites.btn": "Вернуться к событиям",
  "components.routes.pages.Favorites.title": "Избранные",
  "components.routes.pages.Profile.title": "TREND TRADE",
  "components.organisms.BettingCard.yes": "ДА",
  "components.organisms.BettingCard.no": "НЕТ",
  "components.organisms.BettingCard.chooseBtn": "Выберите исход",
  "components.organisms.BettingCard.price": "Цена токена",
  "components.organisms.BettingCard.countToken": "Количество токенов",
  "components.organisms.BettingCard.commision": "Максимальная сумма",
  "components.organisms.BettingCard.pay": "Выплата",
  "components.organisms.BettingCard.save": "Подтвердить",
  "components.molecules.BettingPosition.title": "Ваши позиции",
  "components.molecules.BettingPosition.result": "ИСХОД",
  "components.molecules.BettingPosition.capacity": "ОБЪЕМ",
  "components.molecules.User.profile": "Профиль",
  "components.molecules.User.settings": "Настройки",
  "components.molecules.User.promocode": "Промокоды",
  "components.molecules.User.referal": "Рефералы",
  "components.molecules.User.about": "О бирже",
  "components.molecules.User.logout": "Выйти",
  "components.routes.pages.EventDetail.title": "Детальная страница",
  "components.routes.pages.EventDetail.rules": "Правила",
  "components.organisms.Chart.yes": "да",
  "components.organisms.Chart.no": "нет",
  "components.organimsms.BettingCard.input": "Введите сумму",
  "components.organisms.AuthHeader.login": "Войти",
  "components.organisms.AuthHeader.register": "Регистрация",
  "components.organisms.RegistrationForm.submit": "Зарегистрироваться",
  "components.forms.RegistrationForm.email.placeholder": "Электронная почта",
  "components.forms.RegistrationForm.password": "Пароль",
  "components.organisms.RegistrationModal.title": "Регистрация",
  "components.organisms.RegistrationForm.terms":
    "Я принимаю {link}",
  "components.organisms.RegistrationForm.link": "пользовательское соглашение",
  "components.organisms.RegistrationForm.haveAccount":
    "Уже есть учётная запись? {link}",
  "components.organisms.RegistrationForm.login": "Войти",
  "components.organisms.RegistrationForm.or": "или",
  "components.organisms.RegistrationForm.telegram": "Войти через Telegram",
  "components.forms.LoginForm.email.placeholder": "Электронная почта",
  "components.forms.LoginForm.password": "Пароль",
  "components.organisms.LoginForm.submit": "Войти",
  "components.organisms.LoginForm.haveAccount": "Нет учётной записи?  {link}",
  "components.organisms.LoginForm.register": "Зарегистрироваться",
  "components.organisms.LoginForm.or": "или",
  "components.organisms.LoginForm.telegram": "Войти через Telegram",
  "components.organisms.LoginModal.title": "Вход",
  "components.forms.DepositForm.count.placeholder": "Сумма",
  "components.forms.DepositForm.count.label": "Сумма пополнения",
  "components.forms.DepositForm.cardNumber.placeholder":
    "Номер банковской карты",
  "components.forms.DepositForm.cardNumber.label": "Номер банковской карты",
  "components.forms.DepositForm.date.placeholder": "ММ/ГГ",
  "components.forms.DepositForm.date.label": "Срок действия",
  "components.forms.DepositForm.cvv.placeholder": "000",
  "components.forms.DepositForm.cvv.label": "СVV",
  "components.organisms.DepositForm.save": "Сохранить данные карты",
  "components.organisms.DepositForm.submit": "Пополнить",
  "components.organisms.DepositModal.title": "Пополнение баланса",
  "components.forms.AddEventForm.name.placeholder": "Название события",
  "components.forms.AddEventForm.name.label": "Название события",
  "components.organisms.AddEventForm.result": "Добавить исходы",
  "components.organisms.AddEventForm.resultBtn": "Добавить исход",
  "components.organisms.AddEventForm.submit": "Опубликовать",
  "components.organisms.AddEventModal.title": "Создать событие",
  "components.organisms.AddEventModal.detail": "Добавить исход",
  "components.forms.AddEventForm.date.placeholder": "Введите дату",
  "components.forms.AddEventForm.date.label": "Дата конца события",
  "components.forms.AddEventForm.resultName.placeholder": "Название исхода",
  "components.forms.AddEventForm.resultName.label": "Название исхода",
  "components.organisms.AddEventForm.post": "Добавить",
  "components.molecules.MenuBottomBar.home": "Главная",
  "components.molecules.MenuBottomBar.favorite": "Избранное",
  "components.molecules.MenuBottomBar.menu": "Меню",
  "components.molecules.MobileMenu.portfolio": "Портфолио",
  "components.molecules.MobileMenu.balance": "Баланс",
  "components.organisms.BettingModal.win": "Выплата:",
  "components.templates.CabinetTemplate.notifictaions": "Уведомления",
  "components.organisms.PromoCodeForm.submit": "Подтвердить",
  "components.forms.PromoCodeForm.promocode.placeholder": "Промокод",
  "components.organisms.PromoCodeModal.title": "Введите промокод",
  "components.routes.pages.Histories.table.outputDesk": "Итоговый исход",
  "components.routes.modals.SignUpEmail.title": "Регистрация",
  "components.routes.modals.SingInEmail.title": "Логин",
  "components.atoms.Loader.text": "Загрузка",
  "components.forms.VerifyCodeForm.title": "Введите код",
  "components.forms.VerifyCodeForm.code.placeholder": "Введите код из почты",
  "components.organisms.VerifyCodeForm.submit": "Подтвердить",
  "components.forms.VerifyCodeForm.resend": "Отправить код повторно",
  "components.routes.modals.VerifyCode.title": "Код подтверждения",
  "components.routes.modals.SendResetCode.title": "Код подтверждения",
  "components.organisms.Footer.account.login": "Войти",
  "components.organisms.Footer.account.register": "Регистрация",
  "components.organisms.Footer.account.notifications": "Уведомления",
  "components.atoms.Pagination.text": "из ",
  "components.atoms.PageItemCount.text": "Строк:",
  "components.organisms.NotificationDropdown.noData": "Список пуст",
  "components.routes.pages.Profile.noData": "Список пуст",
  "components.forms.AddEventForm.description.placeholder": "Описание события",
  "components.forms.AddEventForm.description.label": "Описание события",
  "components.organisms.AddEventModal.editTitle": "Редактировать исход",
  "components.organisms.AddEventForm.save": "Сохранить",
  "components.molecules.InfoMessage.title": "Ваше событие на модерации.",
  "components.molecules.InfoMessage.description":
    "Мы пришлём уведомление, как только его проверят и опубликуют.",
  "components.organisms.AddEmailModal.title": "Введите вашу почту и пароль",
  "components.forms.AddEmailForm.email.placeholder": "Введите вашу почту",
  "components.organisms.AddEmailForm.submit": "Подтвердить",
  "components.routes.pages.Profile.showMore": "Показать ещё",
  "components.organisms.ModerationEvenetModal.title": "Событие на модерации",
  "components.organisms.ModerationEvenetModal.description":
    "Событие недоступно, его можно будет просмотреть после одобрения",
  "components.organisms.BettingResultModal.success": "Успешно",
  "components.organisms.BettingResultModal.error": "Ошибка",
  "components.organisms.BettingResultModal.errorDescription":
    "Попробуйте позже",
  "components.organisms.LoginForm.forgetPassword": "Забыли пароль? {link} ",
  "components.organisms.LoginForm.forgetPassword.link": "Восстановить",
  "components.forms.ForgetPasswordForm.email.placeholder": "Электронная почта",
  "components.organisms.ForgetPasswordForm.submit": "Подтвердить",
  "components.routes.modals.ForgetPassword.title": "Восстановление пароля",
  "components.routes.modals.ResetPassword.title": "Создать новый пароль",
  "components.forms.ResetPasswordForm.title": "Создать новый пароль",
  "components.forms.ResetPasswordForm.password": "Пароль",
  "components.forms.ResetPasswordForm.confirmPassword": "Подтвердите пароль",
  "components.forms.ResetPasswordForm.submit": "Сохранить",
  "components.forms.EditUserDataForm.title": "Обновить данные",
  "components.forms.EditUserDataForm.btn": "Сохранить",
  "components.organisms.Chart.stoppedDedline": "Торги приостановлены",
  "components.organisms.Chart.expiredDedline": "Событие завершено",
  "components.organisms.AuthHeader.searchTablet": "Поиск",
  "components.routes.pages.Favorites.select": "Карточек:",
  "components.organisms.OnboardingModal.next": "Дальше",
  "components.organisms.OnboardingModal.finish": "Завершить",
  "components.routes.modals.Deposit.title": "Пополнение",
  "components.routes.modals.DepositAddress.title": "Адрес пополнения",
  "components.routes.modals.Withdraw.title": "Вывод",
  "components.routes.modals.WithdrawForm.title": "Форма вывода",
  "components.routes.modals.CryptoList.title": "Выбор криптовалюты",
};
